class CustomSearch extends SearchForm {
  constructor() {
    super();
    this.inputLabel = this.querySelector('input[type="search"] ~ .field__label');
    this.resultDiv = this.querySelector('.custom-search-results');
    this.brandsOptions = this.querySelector('.field-vendors');
    this.detailsModal = this.closest('details-modal');
    this.abortController = new AbortController();
    this.isOpen = false;
    this.searchTerm = '';
    this.selectedBrand = '';
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.detailsModal.addEventListener('detailOpened', () => {
      this.input.value = '';
      this.removeAttribute('results');
      const selected = this.querySelectorAll('.active');
      this.searchTerm = '';
      if (selected) {
        selected.forEach((button) => button.classList.remove('active'));
        this.selectedBrand = '';
        this.resultDiv.innerHTML = '';
      }
      if (window.innerWidth > 990) return;
      // use setTimeout because of a bug on ios safari
      // https://stackoverflow.com/questions/26347742/safaris-getboundingclientrect-implementation-returns-incorrect-top
      setTimeout(this.setResultsHeight.bind(this), 500);
    });
    window.addEventListener('resize', () => {
      if (window.innerWidth > 990) return;
      this.setResultsHeight();
    });
    this.input.addEventListener('focusout', this.inputFocusOut.bind(this));
    this.brandsOptions.querySelectorAll('.vendor__button').forEach((button) => {
      button.addEventListener('click', this.brandSelected.bind(this, button));
    });
    this.input.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.input.blur();
    });
    this.resultDiv.addEventListener('click', (event) => this.brandLabelEvent(event));
  }

  getQuery() {
    return this.input.value.trim();
  }

  inputFocusOut() {
    if (this.getQuery() && this.getQuery().length > 0) {
      this.inputLabel.classList.add('hidden');
    } else {
      this.inputLabel.classList.remove('hidden');
    }
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      this.resultDiv.innerHTML = '';
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  getSearchResults(searchTerm) {
    !this.selectedBrand ? this.fetchWithoutBrands(searchTerm) : this.fetchWithBrand(searchTerm);
  }

  brandSelected(button) {
    if (this.selectedBrand === button.dataset.vendor) {
      this.selectedBrand = '';
      button.classList.remove('active');
    } else {
      this.selectedBrand = button.dataset.vendor;
      this.brandsOptions.querySelectorAll('.active').forEach((button) => {
        button.classList.remove('active');
      });
      button.classList.add('active');
    }
    this.getSearchResults(this.searchTerm);
  }

  fetchWithBrand(searchTerm) {
    const selectedBrandEncoded = encodeURIComponent(this.selectedBrand);
    fetch(`${routes.search}?q=title:*${encodeURIComponent(searchTerm)}*&filter.p.vendor=${selectedBrandEncoded}&type=product&section_id=search-result-preview`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        this.resultDiv.innerHTML = text;
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }
  fetchWithoutBrands(searchTerm) {
    fetch(`${routes.search}?q=title:*${encodeURIComponent(searchTerm)}*&type=product&section_id=search-result-boolean`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        this.resultDiv.innerHTML = text;
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  brandLabelEvent(e) {
    if (!e.target.classList.contains('custom-search-results__link') && !e.target.parentNode.classList.contains('custom-search-results__link')) return;
    const target = e.target.classList.contains('custom-search-results__link') ? e.target : e.target.parentNode;
    const vendor = target.dataset.vendor;
    this.brandsOptions.querySelector(`[data-vendor="${vendor}"]`).click();
  }

  setResultsHeight() {
    const isOpen = this.detailsModal.querySelector('details').getAttribute('open');
    if (isOpen != 'true') return;
    const divHeight = window.innerHeight - this.resultDiv.getBoundingClientRect().top;
    document.documentElement.style.setProperty('--search-results-height', `${divHeight}px`);
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
      this.resultDiv.innerHTML = '';
    }
    const selected = this.querySelectorAll('.active');

    if (selected) {
      selected.forEach((button) => button.classList.remove('active'));
      this.selectedBrand = '';
    }

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
  }
}
customElements.define('custom-search', CustomSearch);
